export enum EnumPlans {
  BASIC = 1,
  BUSINESS = 3,
  OPERATOR = 4
}

export const PAID_PLANS: readonly EnumPlans[] = [EnumPlans.BUSINESS, EnumPlans.OPERATOR]
